import { render, staticRenderFns } from "./ExamStoreCustomer.vue?vue&type=template&id=4aed2dbe&scoped=true&"
import script from "./ExamStoreCustomer.vue?vue&type=script&lang=js&"
export * from "./ExamStoreCustomer.vue?vue&type=script&lang=js&"
import style0 from "./ExamStoreCustomer.vue?vue&type=style&index=0&id=4aed2dbe&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aed2dbe",
  null
  
)

export default component.exports